// source of truth for device models - https://git.taservs.net/ecom/service-common/blob/master/service-common/src/main/scala/com/evidence/service/common/data/device/Model.scala#L39
export enum PresenceDeviceModels {
  // Presence Models
  AB3 = 'ab3',
  AB4 = 'ab4',
  ABW = 'abw',
  ABW_MINI = 'abwmini',
  Fleet3 = 'fleet3',
  Outpost = 'outpost',
  AxonOutpost = 'axon:outpost',
}
